var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-100"},[_c('user-field-type-options-edit-form',{on:{"on-submit":_vm.onUserFieldTypeOptionsEditSubmit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }